import { ENotificationType, INotification } from "src/notifications/interfaces";
import { InternalCallNotificationMeta } from "../_types/internalCall.types";

export const isSameUserUid = (
  left: string | null | undefined,
  right: string | null | undefined,
): boolean => {
  if (!left || !right) return false;
  return String(left).toLowerCase() === String(right).toLowerCase();
};

const parseJsonRecord = (value: unknown): Record<string, unknown> | null => {
  if (!value) return null;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value) as unknown;
      return typeof parsed === "object" && parsed !== null
        ? (parsed as Record<string, unknown>)
        : null;
    } catch {
      return null;
    }
  }
  if (typeof value === "object") {
    return value as Record<string, unknown>;
  }
  return null;
};

export const normalizeInternalCallNotification = (
  raw: unknown,
  eventType?: ENotificationType,
): INotification<InternalCallNotificationMeta> | null => {
  const payload = parseJsonRecord(raw);
  if (!payload) return null;

  const metaRaw = parseJsonRecord(payload.meta) ?? payload.meta;
  const metaRecord = parseJsonRecord(metaRaw);
  const callUid = metaRecord?.callUid;

  if (typeof callUid !== "string" || !callUid) return null;

  const type =
    (typeof payload.type === "string" ? payload.type : undefined) ?? eventType;

  if (!type) return null;

  return {
    ...(payload as INotification<InternalCallNotificationMeta>),
    type: type as ENotificationType,
    meta: metaRecord as InternalCallNotificationMeta,
  };
};

export const resolveInternalCallEndMessage = (
  type: ENotificationType,
  uid: string,
  meta: InternalCallNotificationMeta,
): string | null => {
  const isCaller = isSameUserUid(meta.callerUid, uid);

  if (type === ENotificationType.InternalCallMissed) {
    return isCaller
      ? "The contact didn't answer the call."
      : "You missed an internal call.";
  }

  if (type === ENotificationType.InternalCallRejected && isCaller) {
    return "The contact declined the call.";
  }

  return null;
};
